<template>
  <div class="fp-preferences-content fp-preferences-content--centered">
    <div class="fourth-step no-border">
      <img class="illustration img-fluid" src='@/assets/images/preferences_illustration_welcome.png' />

      <h5>
        {{ $lang.messages.welcome }}, {{ displayUserName }}
      </h5>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import { GET_REGISTRATION_PROGRESS } from "@/store/action.types";

  export default {
    name: "PreferencesWelcome",
    props: {
      displayUserName: {
        type: Object|String,
        required: true
      }
    },
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters([
        "coparentAdded",
        "childAdded",
        "subscriptionActivated",
        "bankAccountAdded"
      ]),
    },
    mounted() {
      this.getRegistrationProgressAction();
      this.fadeOut();
    },
    methods: {
      ...mapActions({
        getRegistrationProgressAction: GET_REGISTRATION_PROGRESS
      }),
      fadeOut() {
        setTimeout(() => {
          const isSubscriptionPastDue = localStorage.getItem('isSubscriptionPastDue');
          // Guide the user to the User Profile page if
          // - they need to setup the co-parenting
          // - or they need to add children
          if (this.coparentAdded === 'current' || this.childAdded === 'current') {
            this.$router.push({ name: "FamilyProfile" })
          }
          // Guide the user to the Payment Methods page if
          // - they are about to setup a Dwolla account
          // - they are about to add new payment method
          else if (this.subscriptionActivated === 'current' || this.bankAccountAdded === 'current' || isSubscriptionPastDue ) {
            this.$router.push({ name: "PaymentMethods" })
          }
          else if (this.$route.query.payment) {
              this.$router.push( { name: 'PaymentMethods' })
          }
          // In every other case lead them to Dashboard
          else {
            this.$router.push({ name: "Dashboard" })
          }
        }, 2000);
      }
    }
  }
</script>
